import {Expose, Transform, Type} from 'class-transformer';
import {BasicData} from "../basic/BasicData";

export class Survey  extends BasicData {

    static readonly  ModelFeatureAttribute = {
        CLASS_NAME: 'Survey'
    }

    @Expose()
    @Type(() => Number)
    id: string = '';

    @Expose()
    @Type(() => Number)
    surveyId: string = '';

    @Expose()
    unit: string = '';

    @Expose()
    started_at: string = '';

    @Expose()
    finished_at: string = '';

}